import { classNames, classNamesOrEmpty } from "../../style/common"
import { IconProps } from "./common"

export function LBIcon(props: IconProps) {
    return (
        <svg className={classNamesOrEmpty(props.classNames?.svg)} width="100%" height="100%" viewBox="0 0 31 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve">
            <path className={classNames("fill-white stroke-black stroke-1", props.classNames?.path)} d="M4.255,0.008l6.042,-0l-3.219,17.674l8.089,-0.053l1.803,-8.243l11.047,-0.045c3.955,1.794 3.47,8.074 -0.316,10.054c4.553,2.435 3.856,10.223 -2.193,11.63l-13.272,-0l1.767,-8.076l-13.986,0l4.238,-22.941Zm15.475,22.225l-1.011,4.707l4.477,0c1.957,-0.306 2.24,-4.275 -0,-4.707l-3.466,-0Zm1.733,-8.202l-0.809,3.899l3.524,-0c1.354,-0.405 1.515,-3.466 -0,-3.899l-2.715,-0Z" />
        </svg>
    )
}